import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { InitiativeFieldTitles } from '@/features/canvas/constants/initiative-field';
import { components } from '@/types/api';

// Enable custom date format parsing
dayjs.extend(customParseFormat);

export const getInitiativeDates = (initiative?: components['schemas']['Initiative']) => {
  if (!initiative?.fields) {
    // Check for alternative date properties
    const altStartDate =
      (initiative as Record<string, unknown>)?.startDate ||
      (initiative as Record<string, unknown>)?.start_date;
    const altEndDate =
      (initiative as Record<string, unknown>)?.endDate ||
      (initiative as Record<string, unknown>)?.end_date;

    if (altStartDate && altEndDate) {
      return { startDate: altStartDate as string, endDate: altEndDate as string };
    }

    return { startDate: null, endDate: null };
  }

  const startDateField = initiative.fields.find(
    field => field.title === InitiativeFieldTitles.startDate
  );
  const endDateField = initiative.fields.find(
    field => field.title === InitiativeFieldTitles.endDate
  );

  const rawStartDate = startDateField?.value || null;
  const rawEndDate = endDateField?.value || null;

  // Parse dates with DD/MM/YYYY format
  let parsedStartDate = null;
  let parsedEndDate = null;

  if (rawStartDate) {
    // Try DD/MM/YYYY format first
    const startParsed = dayjs(rawStartDate, 'DD/MM/YYYY', true);
    if (startParsed.isValid()) {
      parsedStartDate = startParsed.format('YYYY-MM-DD');
    } else {
      // Fallback to default parsing
      const fallbackStart = dayjs(rawStartDate);
      if (fallbackStart.isValid()) {
        parsedStartDate = fallbackStart.format('YYYY-MM-DD');
      }
    }
  }

  if (rawEndDate) {
    // Try DD/MM/YYYY format first
    const endParsed = dayjs(rawEndDate, 'DD/MM/YYYY', true);
    if (endParsed.isValid()) {
      parsedEndDate = endParsed.format('YYYY-MM-DD');
    } else {
      // Fallback to default parsing
      const fallbackEnd = dayjs(rawEndDate);
      if (fallbackEnd.isValid()) {
        parsedEndDate = fallbackEnd.format('YYYY-MM-DD');
      }
    }
  }

  const result = {
    startDate: parsedStartDate,
    endDate: parsedEndDate,
  };

  return result;
};
